export var Privacy;
(function (Privacy) {
    Privacy["UNKNOWN"] = "UNKNOWN";
    Privacy["PUBLIC"] = "PUBLIC";
    Privacy["PRIVATE"] = "PRIVATE";
})(Privacy || (Privacy = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["TEXT"] = "TEXT";
    Type["NUMBER"] = "NUMBER";
    Type["DATE"] = "DATE";
    Type["URL"] = "URL";
    Type["SOCIAL"] = "SOCIAL";
})(Type || (Type = {}));
export var SocialTypeType;
(function (SocialTypeType) {
    SocialTypeType["UNKNOWN"] = "UNKNOWN";
    SocialTypeType["FACEBOOK"] = "FACEBOOK";
    SocialTypeType["INSTAGRAM"] = "INSTAGRAM";
    SocialTypeType["LINKEDIN"] = "LINKEDIN";
    SocialTypeType["TWITTER"] = "TWITTER";
    SocialTypeType["YOUTUBE"] = "YOUTUBE";
    SocialTypeType["PINTEREST"] = "PINTEREST";
    SocialTypeType["TIKTOK"] = "TIKTOK";
    SocialTypeType["DEVIANTART"] = "DEVIANTART";
    SocialTypeType["SOUNDCLOUD"] = "SOUNDCLOUD";
    SocialTypeType["TUMBLR"] = "TUMBLR";
    SocialTypeType["VIMEO"] = "VIMEO";
    SocialTypeType["VKONTAKTE"] = "VKONTAKTE";
    SocialTypeType["ODNOKLASSNIKI"] = "ODNOKLASSNIKI";
    SocialTypeType["OTHER"] = "OTHER";
})(SocialTypeType || (SocialTypeType = {}));
export var Origin;
(function (Origin) {
    Origin["UNKNOWN"] = "UNKNOWN";
    Origin["CUSTOM"] = "CUSTOM";
    Origin["CONTACT"] = "CONTACT";
    Origin["SYSTEM"] = "SYSTEM";
})(Origin || (Origin = {}));
export var AppliesTo;
(function (AppliesTo) {
    AppliesTo["ALL_MEMBERS"] = "ALL_MEMBERS";
    AppliesTo["SELECTED_MEMBERS"] = "SELECTED_MEMBERS";
})(AppliesTo || (AppliesTo = {}));
export var Section;
(function (Section) {
    Section["GENERAL"] = "GENERAL";
    Section["SOCIAL"] = "SOCIAL";
    Section["DISPLAY_INFO"] = "DISPLAY_INFO";
    Section["ADDRESS"] = "ADDRESS";
})(Section || (Section = {}));
export var State;
(function (State) {
    State["UNKNOWN"] = "UNKNOWN";
    State["ENABLED"] = "ENABLED";
    State["DISABLED"] = "DISABLED";
    State["PENDING"] = "PENDING";
    State["DEMO"] = "DEMO";
})(State || (State = {}));
export var SiteCreatedContext;
(function (SiteCreatedContext) {
    /** A valid option, we don't expose all reasons why site might be created. */
    SiteCreatedContext["OTHER"] = "OTHER";
    /** A meta site was created from template. */
    SiteCreatedContext["FROM_TEMPLATE"] = "FROM_TEMPLATE";
    /** A meta site was created by copying of the transfferred meta site. */
    SiteCreatedContext["DUPLICATE_BY_SITE_TRANSFER"] = "DUPLICATE_BY_SITE_TRANSFER";
    /** A copy of existing meta site. */
    SiteCreatedContext["DUPLICATE"] = "DUPLICATE";
    /** A meta site was created as a transfferred site (copy of the original), old flow, should die soon. */
    SiteCreatedContext["OLD_SITE_TRANSFER"] = "OLD_SITE_TRANSFER";
    /** deprecated A meta site was created for Flash editor. */
    SiteCreatedContext["FLASH"] = "FLASH";
})(SiteCreatedContext || (SiteCreatedContext = {}));
export var Namespace;
(function (Namespace) {
    Namespace["UNKNOWN_NAMESPACE"] = "UNKNOWN_NAMESPACE";
    /** Default namespace for UGC sites. MetaSites with this namespace will be shown in a user's site list by default. */
    Namespace["WIX"] = "WIX";
    /** ShoutOut stand alone product. These are siteless (no actual Wix site, no HtmlWeb). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["SHOUT_OUT"] = "SHOUT_OUT";
    /** MetaSites created by the Albums product, they appear as part of the Albums app. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ALBUMS"] = "ALBUMS";
    /** Part of the WixStores migration flow, a user tries to migrate and gets this site to view and if the user likes it then stores removes this namespace and deletes the old site with the old stores. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["WIX_STORES_TEST_DRIVE"] = "WIX_STORES_TEST_DRIVE";
    /** Hotels standalone (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["HOTELS"] = "HOTELS";
    /** Clubs siteless MetaSites, a club without a wix website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["CLUBS"] = "CLUBS";
    /** A partially created ADI website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ONBOARDING_DRAFT"] = "ONBOARDING_DRAFT";
    /** AppBuilder for AppStudio / shmite (c). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_SITE"] = "DEV_SITE";
    /** LogoMaker websites offered to the user after logo purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["LOGOS"] = "LOGOS";
    /** VideoMaker websites offered to the user after video purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["VIDEO_MAKER"] = "VIDEO_MAKER";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["PARTNER_DASHBOARD"] = "PARTNER_DASHBOARD";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_CENTER_COMPANY"] = "DEV_CENTER_COMPANY";
    /**
     * A draft created by HTML editor on open. Upon "first save" it will be moved to be of WIX domain.
     *
     * Meta site with this namespace will *not* be shown in a user's site list by default.
     */
    Namespace["HTML_DRAFT"] = "HTML_DRAFT";
    /**
     * the user-journey for Fitness users who want to start from managing their business instead of designing their website.
     * Will be accessible from Site List and will not have a website app.
     * Once the user attaches a site, the site will become a regular wixsite.
     */
    Namespace["SITELESS_BUSINESS"] = "SITELESS_BUSINESS";
    /** Belongs to "strategic products" company. Supports new product in the creator's economy space. */
    Namespace["CREATOR_ECONOMY"] = "CREATOR_ECONOMY";
    /** It is to be used in the Business First efforts. */
    Namespace["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
    /** Bookings business flow with no site. */
    Namespace["ANYWHERE"] = "ANYWHERE";
})(Namespace || (Namespace = {}));
export var DeleteStatus;
(function (DeleteStatus) {
    DeleteStatus["UNKNOWN"] = "UNKNOWN";
    DeleteStatus["TRASH"] = "TRASH";
    DeleteStatus["DELETED"] = "DELETED";
    DeleteStatus["PENDING_PURGE"] = "PENDING_PURGE";
})(DeleteStatus || (DeleteStatus = {}));
//# sourceMappingURL=types.js.map